// extracted by mini-css-extract-plugin
module.exports = {"xml_player":"styles_xml_player__1ltSB"};